import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import { QUERY_KEYS } from '@/remote/query-key';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useDeleteInspectionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.inspections.deleteInspection],
    mutationFn: async (id: string): Promise<void> => {
      await XHRAuthorizedClient.delete(ENDPOINTS.inspections.delete(id));
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
};
